import api from './api';

export interface DealerModelRelation {
  dealerId: string;
  dealerName: string;
  modelId: string;
  modelName: string;
  count: number;
}

export interface DealerRevenue {
  dealerId: string;
  dealerName: string;
  revenue: number;
  orderCount: number;
}

export interface Dealer {
  id: string;
  username: string;
}

export interface Analytics {
  dealerModelRelation: DealerModelRelation[];
  dealerRevenue: DealerRevenue[];
  dealers: Dealer[];
  timeRange: {
    startDate: string | null;
    endDate: string | null;
  };
}

export const getAnalytics = async (params?: {
  startDate?: string;
  endDate?: string;
  dealerId?: string;
}): Promise<Analytics> => {
  const response = await api.get<Analytics>('/admin/analytics', { params });
  return response.data;
};

export const exportToCSV = (analytics: Analytics): void => {
  const rows: string[] = [];

  // Header
  rows.push('Analytics Export');
  rows.push(
    `Zeitraum: ${analytics.timeRange.startDate || 'Alle'} - ${analytics.timeRange.endDate || 'Alle'}`
  );
  rows.push('');

  // Section 1: Dealer/Model Relation
  rows.push('Händler/Modell Relation:');
  rows.push('Händler,Modell,Anzahl');
  analytics.dealerModelRelation.forEach(item => {
    rows.push(`${item.dealerName},${item.modelName},${item.count}`);
  });
  rows.push('');

  // Section 2: Dealer/Revenue
  rows.push('Händler/Umsatz:');
  rows.push('Händler,Umsatz (€),Anzahl Bestellungen');
  analytics.dealerRevenue.forEach(item => {
    rows.push(`${item.dealerName},${item.revenue.toFixed(2)},${item.orderCount}`);
  });

  const csvContent = rows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `analytics-${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
